// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import ContactContainer from 'modules/onBoarding/components/Contact'

type PropsType = any

const Contact = (props: PropsType): ReactElement => {
  return (
    <DocumentTitle title={`Step 4 - Contact | ATD`}>
      <>
        <ContactContainer />
      </>
    </DocumentTitle>
  )
}

export default Contact
